import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';

import { DirectiveModule } from '../../directives/directive.module';
import { PipesModule } from '../../pipes/pipes.module';
import { HeaderBoxesComponent } from './header-boxes.component';

@NgModule({
  imports: [CommonModule, PipesModule, DirectiveModule, UiTranslateModule, IconComponent],
  declarations: [HeaderBoxesComponent],
  exports: [HeaderBoxesComponent],
})
export class HeaderBoxesModule {}
